import { Instagram } from 'lucide-react';

import { TikTok } from '@repo/ui/components/icons/tik-tok';
import { cn } from '@repo/ui/lib/utils';
import { Submission } from '@repo/api/open-calls/graphql';

export const CandidateIdentityCard = ({
  className,
  candidate,
  title,
}: {
  className?: string;
  candidate: Submission;
  title?: string;
}) => {
  // TODO (open-call-types): Remove these fallbacks once candidate data is always typed for this view.
  const personalDetails = candidate.data.personalDetails;
  const instagramLink = personalDetails?.instaHandle ?? '';
  const tikTokLink = personalDetails?.tiktokHandle ?? '';
  const displayTitle =
    title ??
    ([candidate.profile.firstName, candidate.profile.lastName]
      .filter(Boolean)
      .join(' ') ||
      'Unnamed candidate');

  return (
    <div
      className={cn(
        'bg-white flex justify-between h-fit p-4 overflow-hidden',
        className,
      )}
    >
      <div className="overflow-hidden w-full">
        <div className="md:text-2xl text-lg font-semibold line-clamp-3 break-words relative">
          {displayTitle}
        </div>
        <div className="text-sm font-light capitalize">
          {candidate.profile.pronouns?.join('/')?.toLowerCase()}
        </div>
      </div>
      <div className="flex size-fit">
        {instagramLink && (
          <a
            target="_blank"
            href={instagramLink}
            className="flex place-items-center cursor-pointer opacity-50 p-2"
          >
            <Instagram className="w-5 h-5" />
          </a>
        )}
        {tikTokLink && (
          <a
            target="_blank"
            href={tikTokLink}
            className="flex place-items-center cursor-pointer opacity-50 p-2"
          >
            <TikTok className="w-5 h-5" />
          </a>
        )}
      </div>
    </div>
  );
};
